import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import React, { useEffect, useState } from "react";
import { inventoryActions } from "redux/Ldb/actions";
import { useParams } from "react-router-dom";

const useGetSalesForecast = (inventoryId?: string) => {
    const dispatch = useAppDispatch();
    const { productId: productIdInUrl } = useParams();
    const productId = inventoryId || productIdInUrl;
    const [dates, setDates] = useState<{ startDate: string; endDate: string }>({
        startDate: "",
        endDate: "",
    });
    const [warehouseId, setWarehouseId] = useState<string>("");
    const [salesForecast, setSalesForecast] = useState<any>([]);
    const [channel, setChannel] = useState("");

    const { fetchingSalesForecast, fetchSalesForecastSuccess } = useAppSelector(
        (state: any) => state.inventory
    );

    const handleChannelChange = (value) => {
        setChannel(value);
        // dispatch(dashboardActions?.resetGetSalesGWMSuccess());
    };

    useEffect(() => {
        if (productId && dates?.startDate && dates?.endDate) {
            dispatch(
                inventoryActions.fetchSalesForecast(
                    productId,
                    warehouseId,
                    dates?.startDate,
                    dates?.endDate,
                    channel
                )
            );
        }
    }, [productId, warehouseId, dates, channel]);

    useEffect(() => {
        if (Boolean(fetchSalesForecastSuccess)) {
            setSalesForecast(fetchSalesForecastSuccess?.monthlyForecasts);
        }
    }, [fetchSalesForecastSuccess]);

    return {
        setDates,
        setWarehouseId,
        salesForecast,
        fetchingSalesForecast,
        handleChannelChange,
        channel,
    };
};

export default useGetSalesForecast;
